import {store} from '../app/store';
import {setActiveSub, setBearerToken, setCurrentSubDetails} from '../features/user/userSlice';
import {checkBearerTokenValidity} from '../Utility/checkToken';
import {axiosInstance} from './axios/AxiosInstance';

export const subscribe = (
  formData,
  userName,
  navigate,
  subscriptionCode,
  paymentService,
  token,
) => {
  console.log(token);
  let subscriptionURL = '';
  let postData = new FormData();
  if (paymentService === 'key') {
    subscriptionURL = `/auth/subscribe/${paymentService}?Key=${formData?.key}`;
  } else if (paymentService === 'paylux') {
    subscriptionURL = `/auth/subscribe/${paymentService}?SubscriptionCode=${subscriptionCode}`;
    postData.append('FirstName', formData?.firstname);
    postData.append('LastName', formData?.lastname);
    postData.append('Address', formData?.address1);
    postData.append('Address2', formData?.address2);
    postData.append('Country', formData?.country);
    postData.append('City', formData?.city);
    postData.append('PostalCode', formData?.zip);
    postData.append('State', formData?.state);
    postData.append('FirstName', formData?.name);
    postData.append('CcNumber', formData?.cc);
    postData.append('Expiry', formData?.expiryMM + formData?.expiryYY);
    postData.append('Cvv', formData?.cvv);
  } else {
    subscriptionURL = `/auth/subscribe/${paymentService}?SubscriptionCode=${subscriptionCode}`;
  }

  let tokenInterceptor = axiosInstance.interceptors.request.use(
    config => {
      checkBearerTokenValidity(userName, navigate);
      console.log('checked bearer');
      return config;
    },
    error => {
      return Promise.reject(error);
    },
  );

  axiosInstance
    .post(subscriptionURL, paymentService === 'paylux' ? postData : null, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
    .then(res => {
      console.log('subscribed');
      axiosInstance.interceptors.request.eject(tokenInterceptor);
      window?.localStorage?.setItem('bearerToken', res?.data?.Token);
      store.dispatch(setActiveSub(true));
      store.dispatch(setCurrentSubDetails(res?.data?.Subscription));
      store.dispatch(setBearerToken(res?.data?.Token));
      navigate('/subexpired');
    })
    .catch(err => console.log('Error in subscribing', err));
};
